(function () {
    'use strict';

    angular
        .module('app')
        .controller('ReviewController', ReviewController);

    ReviewController.$inject = ['$http', '$scope', '$rootScope', '$stateParams', '$state', '$q', '$window', '$transitions', 'emojiReplacer'];

    function ReviewController($http, $scope, $rootScope, $stateParams, $state, $q, $window, $transitions, emojiReplacer) {
        var review = this;
        review.$onInit = init;
        review.createReview = createReview;
        review.close = close;
        review.getTitle = getTitle;
        review.changePage = changePage;
        review.isStartPage = isStartPage;
        review.isLastStep = isLastStep;
        review.hasContent = hasContent;

        function init(){
            $rootScope.header_inverted = false;
            $rootScope.on_dashboard = false;
            $rootScope.separate_page = true;
            $rootScope.dark_text_header = true;
            review.concert_slug = $stateParams.concert_slug;
            review.reviewing_type = 'start';
            review.is_end = false;
            review.alreadyReviewed = false;

            review.new_review = {};
            review.new_review.band = {
                review_rating: 5,
                review_comment: ''
            };
            review.new_review.space = {
                review_rating: 5,
                review_comment: ''
            };

            getConcert()
                .then(function(response){
                    addPages();
                    getTitle();
                });
        }

        function getConcert() {
            return $http.get('api/concerts/'+review.concert_slug+'/')
                .then(function (response) {
                    review.concert = response.data;

                    if(review.concert.user_reviewed && Object.keys(review.concert.user_reviewed).length > 0) {
                        review.alreadyReviewed = true;
                        angular.forEach(review.concert.user_reviewed, function(review_object, type){
                            review.new_review[type].review_comment = review_object.review_comment;
                        });
                    } else {
                        review.concert.user_reviewed = {};
                    }

                    return $q.all([
                        getBand(),
                        getSpace()
                    ])
                });
        }


        function getTitle() { //Title in the top of create_review "You're reviewing (...)"
            if (review.reviewing_type == 'start'){
                if(review.no_host) {
                    review.showing_title = review.concert.concert_name;
                } else {
                    review.showing_title = review.band.band_name + ' at ' + review.space.space_name;
                }
            } else if (review.reviewing_type == 'band'){
                review.showing_title = review.band.band_name;
            } else if (review.reviewing_type == 'space'){
                review.showing_title = review.space.space_name;
            }
        }

        function addPages(){
            if(review.concert.user_is_band_admin){
                review.pages = ['space'];
                review.singleReview = true;
                changePage(1);
            } else if (review.concert.user_is_space_admin){
                review.pages = ['band'];
                review.singleReview = true;
                changePage(1);
            } else if(review.no_host) {
                review.pages = ['band'];
                review.singleReview = true;
                changePage(1);
            } else {
                review.pages = ['band', 'space'];
                changePage(0);
            }
        }

        function hasContent() {
            return review.new_review[review.reviewing_type].review_comment !== "" && review.new_review[review.reviewing_type].review_comment !== undefined;
        }

        function changePage(new_page){
            review.current_page = new_page;
            review.reviewing_type = new_page > 0 ? review.pages[new_page-1] : 'start';
            getTitle();
        }

        function isLastStep() {
            return review.current_page === review.pages.length;
        }

        function isStartPage() {
            return review.reviewing_type === 'start';
        }

        function close() {
            if($rootScope.previousState && typeof $rootScope.previousState.name == 'string'){
                // if the previous state has been set in $transitions hook
                return $state.go($rootScope.previousState.name, $rootScope.previousState.params);
            } else {
                return $state.go('frontpage');
            }
        }

        function getBand(){
            return $http.get('api/bands/'+review.concert.band.band_slug+'/')
                .then(function (response) {
                    review.band = response.data;
                });
        }

        function getSpace(){
            if(!review.concert.space.space_slug) {
                review.no_host = true;
            } else {
                return $http.get('api/spaces/'+review.concert.space.space_slug+'/')
                .then(function (response) {
                    review.space = response.data;
                });
            }

        }

        function createReview() {
            review.create_review_loading = true;

            var data = {
                'review_comment': emojiReplacer.replaceEmojis(review.new_review[review.reviewing_type].review_comment),
                'review_rating': review.new_review[review.reviewing_type].review_rating,
                'review_type': review.reviewing_type,
                'concert_slug': review.concert_slug
            };

            return $http.post('api/reviews/'+review.concert_slug+'/', data).then(function(response){
                review.concert.user_reviewed[review.reviewing_type] = {review_comment: emojiReplacer.replaceEmojis(review.new_review[review.reviewing_type].review_comment)};

                review.create_review_loading = false;

                if(!review.concert.user_is_band_admin && !review.concert.user_is_space_admin && !review.no_host && review.current_page == 1){
                    changePage(2);
                } else {
                    review.is_end = true;
                }

                if(review.reviewing_type == 'user' && review.selected_user != undefined){
                    setUserAsAlreadyReviewed(review.selected_user.user_slug)
                }

            });
        }
    }
})();
